var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "addBigTrafficDialog",
          attrs: {
            title: "添加自行采购的交通产品",
            visible: _vm.dialogVisible,
            width: "60%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm._l(_vm.dataList, function (item, index) {
            return _c("div", { key: index, staticClass: "bigTrafficAdd" }, [
              _c(
                "div",
                { staticClass: "infoDiv" },
                [
                  _c(
                    "p",
                    [
                      _vm._l(_vm.typeObj.radioList, function (item1, index1) {
                        return _c(
                          "el-radio",
                          {
                            key: index1,
                            attrs: { label: item1.value },
                            on: {
                              change: function ($event) {
                                return _vm.changeTrafficType(item, item1.name)
                              },
                            },
                            model: {
                              value: item.trafficType,
                              callback: function ($$v) {
                                _vm.$set(item, "trafficType", $$v)
                              },
                              expression: "item.trafficType",
                            },
                          },
                          [_vm._v(_vm._s(item1.name))]
                        )
                      }),
                      item.trafficType === 1
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "relative",
                                left: "0%",
                                top: "0px",
                                transform: "scale(0.85)",
                              },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.goXc(index)
                                },
                              },
                            },
                            [_vm._v("前往携程>>")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._l(item.detailList, function (item1, index1) {
                    return _c("div", { key: index1 }, [
                      _c(
                        "p",
                        [
                          _c("span", { staticClass: "itemNo" }, [
                            _vm._v(_vm._s(index1 + 1)),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.typeObj.stateProductLabel)),
                          ]),
                          _c("el-input", {
                            staticStyle: { width: "2rem" },
                            attrs: {
                              placeholder: "请输入航班号",
                              size: "small",
                            },
                            model: {
                              value: item1.flightNumber,
                              callback: function ($$v) {
                                _vm.$set(item1, "flightNumber", $$v)
                              },
                              expression: "item1.flightNumber",
                            },
                          }),
                          _c("el-input", {
                            staticStyle: {
                              width: "5.2rem",
                              "margin-left": "0.15rem",
                            },
                            attrs: { placeholder: "备注", size: "small" },
                            model: {
                              value: item1.remark,
                              callback: function ($$v) {
                                _vm.$set(item1, "remark", $$v)
                              },
                              expression: "item1.remark",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        [
                          _c("el-date-picker", {
                            staticClass: "inputDiv",
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.startTimeChange },
                            model: {
                              value: item1.startDate,
                              callback: function ($$v) {
                                _vm.$set(item1, "startDate", $$v)
                              },
                              expression: "item1.startDate",
                            },
                          }),
                          _c("el-time-picker", {
                            staticClass: "inputDiv",
                            attrs: {
                              "default-value":
                                index1 > 0
                                  ? item.detailList[index1 - 1].endTimeDefalut
                                  : item1.startTimeDefalut,
                              "value-format": "HH:mm",
                              placeholder: "出发时间",
                              size: "small",
                              format: "HH:mm",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeTime(
                                  item1,
                                  "startTimeDefalut",
                                  "startDate",
                                  "startTime"
                                )
                              },
                            },
                            model: {
                              value: item1.startTime,
                              callback: function ($$v) {
                                _vm.$set(item1, "startTime", $$v)
                              },
                              expression: "item1.startTime",
                            },
                          }),
                          _c("span", [_vm._v("出发城市")]),
                          _c("city-autocomplete", {
                            attrs: {
                              width: "width:1.8rem;margin-right:0.1rem",
                              obj: item1,
                              placeholderText: "",
                              action: false,
                              sizeType: "small",
                            },
                            on: {
                              handleSelect: function ($event) {
                                return _vm.handleSelect($event, "start", item1)
                              },
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticClass: "inputDiv",
                              attrs: {
                                filterable: "",
                                "allow-create": "",
                                placeholder: "出发" + _vm.typeObj.stateProtName,
                                size: "small",
                              },
                              model: {
                                value: item1.startPortName,
                                callback: function ($$v) {
                                  _vm.$set(item1, "startPortName", $$v)
                                },
                                expression: "item1.startPortName",
                              },
                            },
                            _vm._l(item1.startPortList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.airportNameCn,
                                  value: item.airportNameCn,
                                },
                              })
                            }),
                            1
                          ),
                          _vm.typeObj.state == 1
                            ? _c("el-input", {
                                staticStyle: { width: "1rem" },
                                attrs: {
                                  placeholder: "填写航站楼",
                                  size: "small",
                                },
                                model: {
                                  value: item1.startFlightNo,
                                  callback: function ($$v) {
                                    _vm.$set(item1, "startFlightNo", $$v)
                                  },
                                  expression: "item1.startFlightNo",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        [
                          _c("el-date-picker", {
                            staticClass: "inputDiv",
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.endTimeChange },
                            model: {
                              value: item1.endDate,
                              callback: function ($$v) {
                                _vm.$set(item1, "endDate", $$v)
                              },
                              expression: "item1.endDate",
                            },
                          }),
                          _c("el-time-picker", {
                            staticClass: "inputDiv",
                            attrs: {
                              placeholder: "抵达时间",
                              "default-value": item1.startTimeDefalut,
                              "value-format": "HH:mm",
                              size: "small",
                              format: "HH:mm",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeTime(
                                  item1,
                                  "endTimeDefalut",
                                  "endDate",
                                  "endTime"
                                )
                              },
                            },
                            model: {
                              value: item1.endTime,
                              callback: function ($$v) {
                                _vm.$set(item1, "endTime", $$v)
                              },
                              expression: "item1.endTime",
                            },
                          }),
                          _c("span", [_vm._v("抵达城市")]),
                          _c("city-autocomplete", {
                            attrs: {
                              width: "width:1.8rem;margin-right:0.1rem",
                              obj: item1,
                              placeholderText: "",
                              sizeType: "small",
                              idProName: "endCityId",
                              nameProName: "endCityName",
                              action: false,
                            },
                            on: {
                              handleSelect: function ($event) {
                                return _vm.handleSelect($event, "end", item1)
                              },
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticClass: "inputDiv",
                              attrs: {
                                filterable: "",
                                "allow-create": "",
                                placeholder: "抵达" + _vm.typeObj.stateProtName,
                                size: "small",
                              },
                              model: {
                                value: item1.endPortName,
                                callback: function ($$v) {
                                  _vm.$set(item1, "endPortName", $$v)
                                },
                                expression: "item1.endPortName",
                              },
                            },
                            _vm._l(item1.endPortList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.airportNameCn,
                                  value: item.airportNameCn,
                                },
                              })
                            }),
                            1
                          ),
                          _vm.typeObj.state == 1
                            ? _c("el-input", {
                                staticStyle: { width: "1rem" },
                                attrs: {
                                  placeholder: "填写航站楼",
                                  size: "small",
                                },
                                model: {
                                  value: item1.endFlightNo,
                                  callback: function ($$v) {
                                    _vm.$set(item1, "endFlightNo", $$v)
                                  },
                                  expression: "item1.endFlightNo",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  }),
                ],
                2
              ),
              _c("div", { staticClass: "moneyDiv" }, [
                item.trafficType == 3
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.addFight(item)
                          },
                        },
                      },
                      [_vm._v("添加航班")]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "moneySum" }),
              ]),
              _c(
                "div",
                { staticClass: "budgetDiv" },
                [
                  _vm._l(item.budgetDetailList, function (item1, index1) {
                    return _c(
                      "p",
                      { key: index1 },
                      [
                        _c("span", [_vm._v("乘客类型")]),
                        _c(
                          "el-select",
                          {
                            staticClass: "inputDiv",
                            staticStyle: { width: "1rem" },
                            attrs: {
                              "default-first-option": "",
                              placeholder: "请选择",
                              size: "small",
                            },
                            model: {
                              value: item1.passengerType,
                              callback: function ($$v) {
                                _vm.$set(item1, "passengerType", $$v)
                              },
                              expression: "item1.passengerType",
                            },
                          },
                          _vm._l(_vm.passengerOption, function (item2) {
                            return _c("el-option", {
                              key: item2,
                              attrs: { label: item2, value: item2 },
                            })
                          }),
                          1
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.typeObj.state == 2 ? "座位" : "舱位" + "等级"
                            )
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "inputDiv",
                            staticStyle: { width: "1.2rem" },
                            attrs: {
                              "default-first-option": "",
                              placeholder: "请选择",
                              size: "small",
                            },
                            model: {
                              value: item1.siteType,
                              callback: function ($$v) {
                                _vm.$set(item1, "siteType", $$v)
                              },
                              expression: "item1.siteType",
                            },
                          },
                          _vm._l(_vm.typeObj.siteStepList, function (item2) {
                            return _c("el-option", {
                              key: item2,
                              attrs: { label: item2, value: item2 },
                            })
                          }),
                          1
                        ),
                        _c("span", [_vm._v("成本金额")]),
                        _c("el-input", {
                          staticClass: "inputDiv",
                          staticStyle: { width: "1rem" },
                          attrs: { placeholder: "请输入数字", size: "small" },
                          model: {
                            value: item1.stockPrice,
                            callback: function ($$v) {
                              _vm.$set(item1, "stockPrice", $$v)
                            },
                            expression: "item1.stockPrice",
                          },
                        }),
                        _c("currency-autocomplete", {
                          staticClass: "inputDiv",
                          attrs: {
                            obj: item1,
                            styleStr: "width:0.7rem",
                            sizeType: "small",
                          },
                        }),
                        _c("span", [_vm._v("报价金额")]),
                        _c("el-input", {
                          staticClass: "inputDiv",
                          staticStyle: { width: "1rem" },
                          attrs: { placeholder: "请输入数字", size: "small" },
                          model: {
                            value: item1.ratio,
                            callback: function ($$v) {
                              _vm.$set(item1, "ratio", $$v)
                            },
                            expression: "item1.ratio",
                          },
                        }),
                        _c("span", [_vm._v("乘客人数")]),
                        _c("el-input", {
                          staticClass: "inputDiv",
                          staticStyle: { width: "1rem" },
                          attrs: { placeholder: "请输入数字", size: "small" },
                          model: {
                            value: item1.stockNumber,
                            callback: function ($$v) {
                              _vm.$set(item1, "stockNumber", $$v)
                            },
                            expression: "item1.stockNumber",
                          },
                        }),
                        index1 == 0
                          ? _c("i", {
                              staticClass: "el-icon-circle-plus",
                              staticStyle: {
                                "font-size": "0.2rem",
                                color: "#eeaf99",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addObj(
                                    item.budgetDetailList,
                                    _vm.budgetDetailObj
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        index1 != 0
                          ? _c("i", {
                              staticClass: "el-icon-remove",
                              staticStyle: {
                                "font-size": "0.2rem",
                                color: "#eeaf99",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.delObj(
                                    item.budgetDetailList,
                                    index1
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _c("el-input", {
                    staticStyle: { width: "7.95rem" },
                    attrs: { placeholder: "备注", size: "small" },
                    model: {
                      value: item.remark,
                      callback: function ($$v) {
                        _vm.$set(item, "remark", $$v)
                      },
                      expression: "item.remark",
                    },
                  }),
                ],
                2
              ),
            ])
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addTraffic } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }